<template>
  <div class="outer-wrapper">
    <div class="container-fluid">
      <div class="row justify-content-center">
        
        <div class="ct-col col-md-9">
          <div class="plan-holder">
            <img src="@/assets/images/defaultlogo.jpg" alt="" class="img-fluid b-logo">
            
            <MasterSVG />
            
            <div class="virtula-link-holder">
              <h1>Virtual Site Visit Video</h1>
              <a @click="$bvModal.show('modal-virtual-visit')" href="javascript:void(0)" class="btn-watch"><i class="fa fa-play" style=""><svg id="playIcon" data-name="playIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 438.86 512">
                <path d="M36.57,0,475.43,256,36.57,512Z" transform="translate(-36.57 0)"/>
              </svg></i>Watch Now</a>
            </div>
          </div>
        </div>
        
        <div class="ct-col col-md-3">
          <Typologies />
          <Floors />
        </div>
      </div>
    </div>
    <ArialView />
    <VirtualVisit />
  </div>
</template>
<script>
import ArialView from '@/components/Home/AerialView.vue';
import MasterSVG from '@/components/MasterSVG.vue';
import Typologies from '@/components/Home/Typologies.vue';
import VirtualVisit from '@/components/Home/VirtualVisit.vue';
import Floors from '@/components/Home/Floors.vue';
export default {
  components: {
    MasterSVG,
    Typologies,
    Floors,
    VirtualVisit,
    ArialView
  },
  mounted(){
    $(".side-menu.next").css({"display": "none", });
    $('.nextButton').click(function(){
    $(".side-menu.prev").css({"display": "none", });
    $(".side-menu.next").css({"display": "block", });
    });
    $('.prevButton').click(function(){
    $(".side-menu.prev").css({"display": "block", });
    $(".side-menu.next").css({"display": "none", });
    });
  }
}
</script>